import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Hotel from "./views/Hotel.vue";
import Spa from "./views/Spa.vue";
import Restaurante from "./views/Restaurante.vue";
import Yoga from "./views/Yoga.vue";
import Zipolite from "./views/Zipolite.vue";
import Contacto from "./views/Contacto.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/hotel",
      name: "hotel",
      component: Hotel
    },
    {
      path: "/spa",
      name: "spa",
      component: Spa
    },
    {
      path: "/restaurante",
      name: "restaurante",
      component: Restaurante
    },
    {
      path: "/yoga",
      name: "yoga",
      component: Yoga
    },
    {
      path: "/zipolite",
      name: "zipolite",
      component: Zipolite
    },
    {
      path: "/contacto",
      name: "contacto",
      component: Contacto
    }
  ]
});
